import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { TariffSummaryResults } from '../../../../assets/js/com/ts_api_client';

@Component({
    selector: 'bdo-tariff-prices-cost-info',
    templateUrl: './tariff-prices-cost-info.component.html',
    styleUrls: ['./tariff-prices-cost-info.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TariffPricesCostInfoComponent {
  @Input() tariffData: TariffSummaryResults;
}
